@if (isVisible()) {
    <div>
        <div class="bar-startscherm__picker">
            <button
                matTooltipClass="sta-voorwiepicker-tooltip"
                [matTooltip]="client() ? voorwieTooltip() : ''"
                class="bar-startscherm__picker-main"
                (click)="search()"
            >
                <span [class]="{ 'visually-hidden': client(), 'bar-startscherm__picker-placeholder': !client() }">
                    {{ 'DOMAIN_STARTSCHERM.VOORWIE.PLACEHOLDER' | i18n }}
                </span>
                @if (client()) {
                    <span>
                        <span class="visually-hidden">{{ 'DOMAIN_STARTSCHERM.VOORWIE.CURRENT' | i18n }}</span>
                        {{ client() }} ({{ klantnummer() }})
                    </span>
                }
            </button>
            <div class="bar-startscherm__picker-actions">
                @if (voorwieChosen()) {
                    <button (click)="reset()" [attr.aria-label]="'DOMAIN_STARTSCHERM.VOORWIE.CLEAR' | i18n">
                        <span class="fa fa-times"></span>
                    </button>
                }
                <button (click)="search()" aria-hidden="true" tabindex="-1">
                    <span class="fa fa-search"></span>
                </button>
            </div>
        </div>
    </div>
}
